import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';

// Sentry.init({
//   dsn: "https://b65263bc7544dc683ecd8388701216b3@o4509191571243008.ingest.de.sentry.io/4509192905031760",
//   environment: environment.production ? 'stg' : 'prd',
//   sendDefaultPii: environment.production,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.browserProfilingIntegration(),
//     Sentry.replayIntegration({
//       // Mask all text input fields in session replays
//       maskAllText: true,
//       // Block all media (images, videos, etc.) from being recorded
//       blockAllMedia: true,
//     }),
//   ],
//   // prevent cors issues by avoiding trace headers on api calls
//   tracePropagationTargets: [],
//   // Capture 20% of performance traces — enough to monitor performance trends
//   tracesSampleRate: environment.production ? 0.2 : 1.0,
//   // Sample 10% of sessions for profiling (CPU/memory) to keep costs reasonable
//   profilesSampleRate: environment.production ? 0.1 : 1.0,
//   // Only capture 1% of sessions — adjust based on volume
//   replaysSessionSampleRate: environment.production ? 0.01 : 0.5,
//   // Capture 100% of sessions where an error occurs — helps debugging
//   replaysOnErrorSampleRate: 1.0,
// });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
